//
import Service from '@/services/api/service'
import AccAccountingBankCardModel from '@/models/Accounting/AccAccountingBankCard'

/**
 * This class describes a sl tax document.
 *
 * @class      SlTaxDocument (name)
 */
export default class AccAccountingBankCardChile extends Service {

  /**
   * { item_description }
   */
  static includes = [
    'accounting_bank_card_branch_office',
    'accounting_bank_card_movement_detail',
  ]

  /**
   * { item_description }
   */
  static model = AccAccountingBankCardModel
}
